var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"12px 12px 0px"}},[_c('index-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }